module.exports = __webpack_public_path__ + "img/hover.65535924.png";